export const assetsEndpoints = {
  collection: (projectId: string) => `/api/projects/${encodeURIComponent(projectId)}/assets`,
  upload: (projectId: string) => `/api/projects/${encodeURIComponent(projectId)}/assets/upload`,
}
